import Skeleton from "react-loading-skeleton";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";

export function AcuityUpdateAlertSkeleton() {
  return (
    <DashboardCard2 rawChildren>
      <div className="tw:grid tw:gap-3.5 tw:lg:items-center tw:lg:justify-between">
        {/* Heading */}
        <Skeleton height={25} width="45%" />

        {/* DL rows */}
        <div className="tw:flex tw:flex-col tw:gap-2.5 tw:lg:col-start-1 tw:lg:row-start-2">
          <Skeleton height={14} width="80%" />
          <Skeleton height={25} width={180} />
          <Skeleton height={14} width="35%" />
        </div>

        {/* Buttons */}
        <div className="tw:flex tw:justify-end tw:gap-3 tw:lg:col-start-2 tw:lg:row-span-2">
          <Skeleton height={36} width={90} />
          <Skeleton height={36} width={90} />
        </div>
      </div>
    </DashboardCard2>
  );
}
